<template>
  <div id="product-detail">
    <v-layout align-center row wrap>
      <v-flex md4 py-0 sm6 xs10>
        <v-img
          :lazy-src="require('@/assets/NoPicture.png')"
          :src="picture"
          aspect-ratio="1"
        ></v-img>
      </v-flex>
      <v-flex md4 sm6 xs12>
        <div class="headline">{{ products.productname }}</div>
        <div class="caption text-uppercase">
          {{ products.productnameeng || 'None English Name' }}
        </div>
        <div class="subheading mt-2">{{ grades.name || 'ไม่ได้ะบุ' }}</div>
        <div class="subheading">{{ certificates.nametha }}</div>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: '',
  props: {
    qrcodeId: {
      type: String
    }
  },
  data() {
    return {
      products: [],
      varietys: [],
      grades: [],
      certificates: []
    }
  },
  computed: {
    picture() {
      if (this.varietys.mainpictureurl) {
        return this.varietys.mainpictureurl
      } else if (this.products.mainpictureurl) {
        return this.products.mainpictureurl
      } else {
        return require('@/assets/NoPicture.png')
      }
    }
  },
  async created() {
    const states = await this.fetchData()
    this.getProduct(states)
    this.getVariety(states)
    this.getGrade(states)
    this.getCertificate(states)
  },
  methods: {
    async fetchData() {
      try {
        const response = await this.axios.get(`cropperz/qrcode/${this.qrcodeId}`)
        return response.data[0]
      } catch (error) {
        throw new Error(error)
      }
    },
    async getProduct(states) {
      try {
        const response = await this.axios.get(`portal/products/details/${states.productId}`)
        this.products = response.data[0]
      } catch (error) {
        throw new Error(error)
      }
    },
    async getVariety(states) {
      try {
        const response = await this.axios.get(`portal/varietys/details/${states.productId}`)
        this.varietys = response.data[0]
      } catch (error) {
        throw new Error(error)
      }
    },
    async getGrade(states) {
      try {
        const response = await this.axios.get(`portal/grade/details/${states.gradeId}`)
        this.grades = response.data[0]
      } catch (error) {
        throw new Error(error)
      }
    },
    async getCertificate(states) {
      try {
        const response = await this.axios.get(`cropperz/groups/certificate/${states.farmId}`)
        if (response.data) {
          const certificates = await this.axios.get(
            `portal/certificate/details/${response.data[0].certificateId}`
          )
          this.certificates = certificates.data[0]
        }
      } catch (error) {
        throw new Error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
